import React from "react";

import { IgButton, IgTooltip } from "@intelligems/ig-theme";
import { useGetOrg } from "@src/api/organizations/get-organization";

export function AddImagesFrontend() {
  const organization = useGetOrg();

  const openLibrary = () => {
    const shopId = organization.data.org.shopId?.split(".")[0];
    const url = `https://admin.shopify.com/store/${shopId}/content/files`;
    window.open(url, "_blank", "noopener noreferrer");
  };

  return (
    <IgTooltip title="Add new images in Shopify. Click the refresh button to update the list.">
      <IgButton variant="contained" color="secondary" onClick={openLibrary}>
        Add Images via Shopify
      </IgButton>
    </IgTooltip>
  );
}
